export type CoverageBenefitsPanelArticles = {
  icon: React.ReactNode;
  description: string;
  additionalDescription?: string;
};

export type CoverageBenefitsPanelProps = {
  discountPercentage?: number;
  discountTerm?: number;
  show2MonthsPromotion?: boolean;
  netFirstPaymentAmount: number;
  netFirstPaymentAmountAfterPromotionalPeriod?: number;
  periodOfCover: number;
  discountPaymentType?: 'cc' | 'ach';
  coverageBenefitsPanelArticles: CoverageBenefitsPanelArticles[];
};

export const CoverageBenefitsPanel = ({
  netFirstPaymentAmount,
  netFirstPaymentAmountAfterPromotionalPeriod,
  show2MonthsPromotion,
  discountPercentage,
  discountTerm,
  discountPaymentType,
  coverageBenefitsPanelArticles,
}: CoverageBenefitsPanelProps) => {
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const discountIsAch = discountPaymentType === 'ach';

  const discountText = `Plus, get ${discountPercentage}% off for ${discountTerm} months ${discountIsAch ? '*' : ''}`;
  const payment = (
    <h3 className="text-headline">
      {!!netFirstPaymentAmountAfterPromotionalPeriod &&
        !show2MonthsPromotion &&
        netFirstPaymentAmount < netFirstPaymentAmountAfterPromotionalPeriod && (
          <span className="line-through text-button-text-outline-disabled mr-2">
            {currencyFormatter.format(netFirstPaymentAmountAfterPromotionalPeriod)}
          </span>
        )}
      {currencyFormatter.format(netFirstPaymentAmount)} a month
    </h3>
  );

  return (
    <div className="grid grid-cols-4 p-space-500 border-2 border-brand-primary rounded-radius-400 bg-primary-50 w-full">
      <h3 className="col-span-4 text-h3 border-b b-1 border-brand-primary pb-space-500">
        Enhanced coverage with Whirlpool Appliance Care
      </h3>
      <div className="col-span-4 py-space-500 grid grid-cols-1 desktop:grid-cols-4 gap-space-700 border-b b-1 border-brand-primary">
        {coverageBenefitsPanelArticles.map((article, index) => (
          <article
            className="flex flex-row items-center desktop:flex-col test-left desktop:text-center max-w-64 gap-space-100"
            key={index}
          >
            <figure className="text-brand-primary rounded-full bg-white p-3 flex items-center justify-center mr-space-200">
              {article.icon}
            </figure>
            <div>
              <p className="text-body-large-strong">{article.description}</p>
              <p className="text-body">{article.additionalDescription}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="col-span-4 flex flex-col gap-space-200 my-space-400">
        <h4 className="text-success-600 text-h4">{discountText}</h4>
        {payment}
        <p>Cancel anytime</p>
      </div>
      {discountIsAch && (
        <p className="col-span-4 text-text-body">
          *Discount applies to payments made via bank account only. Applicable taxes calculated
          during checkout.
        </p>
      )}
    </div>
  );
};
